import { render } from "./component-payer-bik.vue?vue&type=template&id=daa782a2"
import script from "./component-payer-bik.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-bik.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-bik.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "daa782a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('daa782a2', __exports__)) {
    api.reload('daa782a2', __exports__)
  }
  
  module.hot.accept("./component-payer-bik.vue?vue&type=template&id=daa782a2", () => {
    api.rerender('daa782a2', render)
  })

}


export default __exports__